"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _consts = require("./utils/consts");
var MEMORYSTORAGE = {
  _SESSIONSTORAGE: {},
  _LOCALSTORAGE: {}
};
var FALLBACKTOCOOKIE = false;
var SUPPORTSLOCALSTORAGE = true;
var SUPPORTSSESSIONSTORAGE = true;
var EXPIRED_TIME = -1000;
var Storage = /*#__PURE__*/function () {
  function Storage() {
    (0, _classCallCheck2["default"])(this, Storage);
  }
  (0, _createClass2["default"])(Storage, null, [{
    key: "setInCookie",
    value: function setInCookie(key, value, isSession, expHours, domain, path, secure) {
      var hours = typeof expHours !== 'undefined' ? expHours : _consts.DAYS_IN_YEAR * _consts.HOURS_IN_DAY;
      var date = new Date();
      var domainStr = domain ? "; Domain=".concat(domain) : '';
      var pathStr = path ? "; Path=".concat(path) : '; Path=/';
      var secureStr = secure ? '; secure' : '';
      date.setTime(date.getTime() + hours * _consts.MINUTES_IN_HOUR * _consts.MILLIS_IN_MINUTE);
      var expStr = isSession ? '' : "; Expires=".concat(date.toGMTString());
      document.cookie = "".concat(key, "=").concat(value).concat(domainStr).concat(expStr).concat(pathStr).concat(secureStr);
    }
  }, {
    key: "getFromCookie",
    value: function getFromCookie(key) {
      if (document.cookie) {
        var keyDel = "".concat(key, "=");
        var cind = document.cookie.split(';');
        for (var i = 0, l = cind.length; i < l; i++) {
          var c = cind[i];
          while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
          }
          if (c.indexOf(keyDel) === 0) {
            return c.substring(keyDel.length, c.length);
          }
        }
      }
      return null;
    }
  }, {
    key: "eraseCookie",
    value: function eraseCookie(key) {
      this.setInCookie(key, '', true);
    }
  }, {
    key: "expireCookie",
    value: function expireCookie(key, cookieDomain) {
      this.setInCookie(key, '', false, EXPIRED_TIME, cookieDomain);
      if (cookieDomain.match(/\.[^.]+\.[^.]+\./)) {
        // Clear parent domain as well;
        this.setInCookie(key, '', false, EXPIRED_TIME, cookieDomain.replace(/\.[^.]+/, ''));
      }
    }

    // Internal method to determine if cookie should be used for storage
  }, {
    key: "_shouldUseCookie",
    value: function _shouldUseCookie(type) {
      return type === 'cookie' || !this._hasSupportedStorageType(type) && FALLBACKTOCOOKIE;
    }

    // Internal method to test if "local" or "session" storage type is supported
  }, {
    key: "_hasSupportedStorageType",
    value: function _hasSupportedStorageType(type) {
      return type === 'local' && SUPPORTSLOCALSTORAGE || type === 'session' && SUPPORTSSESSIONSTORAGE;
    }

    /*
     * Internal method to get one of the three storage types.
     * (or auto fallback to memoryStore)
     */
  }, {
    key: "_getDaStorage",
    value: function _getDaStorage(type) {
      switch (type) {
        case 'local':
          return this._hasSupportedStorageType(type) ? localStorage : MEMORYSTORAGE._LOCALSTORAGE;
        case 'session':
          return this._hasSupportedStorageType(type) ? sessionStorage : MEMORYSTORAGE._SESSIONSTORAGE;
        case 'memory':
          return MEMORYSTORAGE;
      }
    }

    /*
     * Remove the key/value pair for a given key
     * NO COOKIE SUPPORT
     */
  }, {
    key: "removeItem",
    value: function removeItem(key, type, dastorage) {
      dastorage = dastorage || this._getDaStorage(type);
      if (dastorage.removeItem) {
        // This is for either localStorage or sessionStorage
        dastorage.removeItem(key);
      } else {
        // This is for the memoryStore
        delete dastorage[key];
      }
    }

    /*
     * Return number of key/value pairs that are stored
     * NO COOKIE SUPPORT
     */
  }, {
    key: "getLength",
    value: function getLength(type, dastorage) {
      dastorage = dastorage || this._getDaStorage(type);
      var _dastorage = dastorage,
        length = _dastorage.length;
      if (typeof length !== 'undefined') {
        // This is for either localStorage or sessionStorage
        return length;
      }

      // This is for the memoryStore
      return Object.keys(dastorage).length;
    }

    /*
     * Clear all expired key/value pairs
     * NO COOKIE SUPPORT
     */
  }, {
    key: "clearExpired",
    value: function clearExpired(type) {
      var dastorage = this._getDaStorage(type);
      var length = this.getLength(type, dastorage);
      for (var i = length; i; i--) {
        /*
         * Access all items - the act of getting them will automatically remove
         * them if they are expired
         */
        this.getItem(this.getKey(i - 1, type, dastorage), type, dastorage);
      }
    }

    /*
     * Storage functions: `key` (string), `value` (string or json object). All
     * values are stored as stringified json. `type` indicates whether to store
     * in "session"Storage (default), "local"Storage or "memory".
     * `exp` is expiration time in milliseconds
     *
     * NOTE: setItem() can throw a QuotaExceededError exception if storage is
     * full. That case should be handled at application level; we don't want to
     * add a try/catch block here.
     */
  }, {
    key: "setItem",
    value: function setItem(key, value, type, exp) {
      var success = false;
      var dastorage = this._getDaStorage(type);
      var timestamp = new Date().getTime();
      if (typeof value === 'undefined' || value === null) {
        this.removeItem(key, type, dastorage);
      }
      var jsonv = {
        _data_: value,
        _ts_: timestamp
      };
      if (exp) {
        jsonv._exp_ = timestamp + exp;
      }
      if (typeof JSON !== 'undefined') {
        // Opera Mini (and maybe others) does not store values with double quotes, so replace them;
        var jsonvStr = JSON.stringify(jsonv).replace(/"/g, '^^');
        if (this._shouldUseCookie(type)) {
          this.setInCookie(key, jsonvStr);
        } else {
          // First do some housekeeping and remove expired items
          this.clearExpired(type);

          /*
           * Store the new item
           * QUESTION: Should this be placed in try-catch? If so, what would
           * the recovery action be? Clear the whole cache? Clear oldest
           * item(s) untill action succeeds?
           */
          if (typeof dastorage.setItem !== 'undefined' && dastorage.removeItem !== 'undefined') {
            // To prevent "quota exceeded" errors on iPad, the storage item needs to be removed before updating;
            dastorage.removeItem(key);
            dastorage.setItem(key, jsonvStr);
          } else {
            dastorage[key] = jsonvStr;
          }
        }
        success = true;
      }
      return success;
    }

    // Retrieve the value for the given key
  }, {
    key: "getItem",
    value: function getItem(key, type, dastorage) {
      var jsonv;
      var jsonvStr;
      dastorage = dastorage || this._getDaStorage(type);
      if (this._shouldUseCookie(type)) {
        jsonvStr = this.getFromCookie(key);
      } else if (typeof dastorage.getItem !== 'undefined') {
        jsonvStr = dastorage.getItem(key);
      } else {
        jsonvStr = dastorage[key];
      }
      if (typeof JSON !== 'undefined' && typeof jsonvStr !== 'undefined' && jsonvStr !== null) {
        /*
         * Perform a sanity check to ensure this value was set by storage and
         * can be parsed safely
         */
        if (jsonvStr.indexOf('^^_ts_^^') !== -1) {
          jsonv = JSON.parse(jsonvStr.replace(/\^\^/g, '"'));
          if (jsonv._exp_ && new Date().getTime() > jsonv._exp_) {
            // Value has expired
            jsonv = null;
            // Remove it
            this.removeItem(key, type, dastorage);
          }
        } else {
          /*
           * This is not a value that was set using the storage, we're not sure
           * it's stringified JSON, so just return the plain value.
           */
          jsonv = jsonvStr;
        }
      } else {
        jsonv = null;
      }
      return jsonv ? jsonv._data_ : jsonv;
    }

    /*
     * Retrieve the i-th key in the list of stored keys
     * NO COOKIE SUPPORT
     */
  }, {
    key: "getKey",
    value: function getKey(i, type, dastorage) {
      var key;
      dastorage = dastorage || this._getDaStorage(type);
      if (dastorage.key) {
        // This is for either localStorage or sessionStorage
        key = dastorage.key(i);
      } else {
        // This is for the memoryStore here which does not have a key() method
        key = dastorage.map(function (value, key) {
          return key;
        })[i];
      }
      return key;
    }

    /*
     * Clear all key/value pairs
     * NO COOKIE SUPPORT
     * !!! CAREFUL: This clears everything in storage, not just items that
     * were set with this app, also anything some other app on the same
     * host might have stored!!!
     */
  }, {
    key: "clear",
    value: function clear(type) {
      var dastorage = this._getDaStorage(type);
      if (dastorage.clear) {
        // This is for either localStorage or sessionStorage
        dastorage.clear();
      } else if (type === 'local' || type === 'session') {
        /*
         * This is for the memoryStore
         * NOTE: `dastorage = {}` won't work, we need to reset each
         * property explicitly individually
         */

        MEMORYSTORAGE["_".concat(type, "Storage")] = {};
      } else {
        MEMORYSTORAGE = {};
      }
    }

    /*
     * Clear namespaced key/value pairs
     * NO COOKIE SUPPORT
     */
  }, {
    key: "clearNamespaced",
    value: function clearNamespaced(ns, type) {
      var dastorage = this._getDaStorage(type);
      var length = this.getLength(type, dastorage);
      ns = "".concat(ns, ":").replace(/::/g, ':');
      for (var i = length; i; i--) {
        var key = this.getKey(i - 1, type, dastorage);
        if (key.indexOf(ns) === 0) {
          this.removeItem(key, type, dastorage);
        }
      }
    }

    /*
     * Convience methods for localStorage and sessionStorage
     * There are no convenience methods for type "memory" and "cookie" because
     * those are used rarely. They should be accessed directly when required.
     */

    // Convenience methods for localStorage
  }, {
    key: "setLocalItem",
    value: function setLocalItem(key, value, exp) {
      return this.setItem(key, value, 'local', exp);
    }
  }, {
    key: "getLocalItem",
    value: function getLocalItem(key) {
      return this.getItem(key, 'local');
    }
  }, {
    key: "getLocalKey",
    value: function getLocalKey(i) {
      return this.getKey(i, 'local');
    }
  }, {
    key: "getLocalLength",
    value: function getLocalLength() {
      return this.getLength('local');
    }
  }, {
    key: "removeLocalItem",
    value: function removeLocalItem(key) {
      return this.removeItem(key, 'local');
    }
  }, {
    key: "clearLocal",
    value: function clearLocal() {
      return this.clear('local');
    }
  }, {
    key: "clearLocalExpired",
    value: function clearLocalExpired() {
      return this.clearExpired('local');
    }
  }, {
    key: "clearLocalNamespaced",
    value: function clearLocalNamespaced(ns) {
      return this.clearNamespaced(ns, 'local');
    }

    // Convenience methods for sessionStorage
  }, {
    key: "setSessionItem",
    value: function setSessionItem(key, value, exp) {
      return this.setItem(key, value, 'session', exp);
    }
  }, {
    key: "getSessionItem",
    value: function getSessionItem(key) {
      return this.getItem(key, 'session');
    }
  }, {
    key: "getSessionKey",
    value: function getSessionKey(i) {
      return this.getKey(i, 'session');
    }
  }, {
    key: "getSessionLength",
    value: function getSessionLength() {
      return this.getLength('session');
    }
  }, {
    key: "removeSessionItem",
    value: function removeSessionItem(key) {
      return this.removeItem(key, 'session');
    }
  }, {
    key: "clearSession",
    value: function clearSession() {
      return this.clear('session');
    }
  }, {
    key: "clearSessionExpired",
    value: function clearSessionExpired() {
      return this.clearExpired('session');
    }
  }, {
    key: "clearSessionNamespaced",
    value: function clearSessionNamespaced(ns) {
      return this.clearNamespaced(ns, 'session');
    }
  }]);
  return Storage;
}();
exports["default"] = Storage;